import React from 'react';
import PropTypes from 'prop-types';

import { Wrap, Icon, Name } from './styled';

const Item = ({ name, permalink, iconPath, onClick }) => (
    <Wrap external={false} to={permalink} onClick={onClick} type="catalog-link">
        {iconPath && <Icon iconPath={iconPath} />}
        <Name>{name}</Name>
    </Wrap>
);

Item.propTypes = {
    name: PropTypes.string,
    permalink: PropTypes.string,
    iconPath: PropTypes.string,
    onClick: PropTypes.func,
};

Item.defaultProps = {
    name: '',
    permalink: '',
    iconPath: '',
    onClick: () => {},
};

export default Item;
